module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this"), _c('br'), _vm._v("novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THOMAS DUNNE BOOKS")]), _vm._v("."), _c('br'), _vm._v("An imprint of St. Martin’s Press.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO TRY MEN’S SOULS")]), _vm._v(". Copyright © 2009 by Newt Gingrich and William R. Forstchen."), _c('br'), _vm._v("All rights reserved. Printed in the United States of America."), _c('br'), _vm._v("For information, address St. Martin’s Press, 175 Fifth Avenue,"), _c('br'), _vm._v("New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thomasdunnebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thomasdunnebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Book design by Jonathan Bennett")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gingrich, Newt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    To try men’s souls : a novel of George Washington and the fight for American freedom / Newt Gingrich and William R. Forstchen.——1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("        p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    ISBN: 978-1-4299-6881-2")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. Washington, George, 1732—1799——Fiction. 2. Paine, Thomas,"), _c('br'), _vm._v("1737—1809——Fiction. 3. United States——History——Revolution,"), _c('br'), _vm._v("1775—1783——Fiction. I. Forstchen, William R. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    PS3557.I4945T6 2009")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    813' .54——dc22")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para1"
  }, [_vm._v("2009024679")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("First Edition: October 2009")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0